<template>
  <div class="student-side-menu">
    <div class="user-info">
      <a-avatar
        style="backgroundcolor: #87d068; border-radius: 50%; padding: 0"
        shape="square"
        icon="user"
        :src="avatarUrl"
      />
      <h3 style="margin-top: 10px">
        {{ $store.state.user ? $store.state.user.info.realname : '' }}
      </h3>
      <!-- <p>优秀作业 {{userCountInfo.workGreatTotal}}</p>
        <p>(作业总数 {{userCountInfo.workTotal}})</p> -->
    </div>
    <a-divider style="width: 80%"></a-divider>
    <div v-if="userIdentity == 2">
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-menu-item key="home">
            <router-link to="home"> <i class="iconfont">&#xf0fe;</i>  教室首页</router-link>
        </a-menu-item>
       
        <a-menu-item key="myClass">
            <router-link to="myClass"><i class="iconfont">&#xe600;</i>我的班级</router-link>
        </a-menu-item>
        <!-- <a-menu-item key="classroomComments">
            <router-link to="classroomComments"><i class="iconfont">&#xe60c;</i>课堂点评</router-link>
        </a-menu-item> -->
        <a-sub-menu key="zuoping"  >
            <template slot="title">
                <span class="menuTitle"><i class="iconfont">&#xe75f;</i>作品管理</span>
                
            </template>
            <a-menu-item key="xuesheng" class="ziMenu"><router-link to="studentWorks">学生作品</router-link></a-menu-item>
            <a-menu-item key="wode" class="ziMenu"><router-link to="myWorks">我的作品</router-link></a-menu-item>
        </a-sub-menu>
        <a-menu-item key="LessonPreparationCenter">
            <router-link to="LessonPreparationCenter"><i class="iconfont">&#xe60b;</i>备课中心</router-link>
        </a-menu-item>
        <a-menu-item key="trainingForTeachers">
            <router-link to="trainingForTeachers"><i class="iconfont">&#xe603;</i>师资培训</router-link>
        </a-menu-item>
        <a-menu-item key="teachingActivities">
            <router-link to="teachingActivities"><i class="iconfont">&#xe8ce;</i>教研活动</router-link>
        </a-menu-item>
      </a-menu>
    </div>
    <div v-if="userIdentity == 1">
      <a-menu mode="inline" @click="handleClick" v-model="selectedKeys">
        <a-menu-item key="home">
            <router-link to="home"><i class="iconfont">&#xf0fe;</i>教室首页</router-link>
        </a-menu-item>
       
        <a-menu-item key="LessonPreparationCenter">
            <router-link to="LessonPreparationCenter"><i class="iconfont">&#xe60b;</i>我的课程</router-link>
        </a-menu-item>
        <a-menu-item key="studentMyclass">
            <router-link to="studentMyclass"><i class="iconfont">&#xe600;</i>我的班级</router-link>
        </a-menu-item>
        <a-sub-menu key="zuoping"  >
            <template slot="title">
                <span class="menuTitle"><i class="iconfont">&#xe75f;</i>作品管理</span>
            </template>
            <a-menu-item key="xuesheng" class="ziMenu"><router-link to="classWorks">班级作品</router-link></a-menu-item>
            <a-menu-item key="wode" class="ziMenu"><router-link to="myWorks">我的作品</router-link></a-menu-item>
        </a-sub-menu>
      </a-menu>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import { getAction } from "@/api/manage";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import config from "../theme.config";
import { getQiniuUrl } from "@/utils/qiniu.js";
import { HomeFilled  } from '@ant-design/icons-vue'
import { Icon } from 'ant-design-vue';

export default {
  name: "SideMenu",
  data() {
    return {
      selectedKeys: ['home'],
      userCountInfo: {},
      token: "",
    };
  },
  components:{'a-icon': Icon,},
  watch:{
    '$route'(to, from) {
      // console.log(to , 'to')
      this.selectedKeys[0] = to.meta.key ? this.selectedKeys[0] : to.name
      this.$forceUpdate()
    },
  },
  
  computed: {
    avatarUrl() {
      if (this.$store.state.user.avatar) {
        return this.$store.state.user.avatar;
      } else if (
        this.$store.state.user.info &&
        this.$store.state.user.info.avatar
      ) {
        return this.$store.state.user.info.avatar;
      } else {
        return "/img/avatar.png";
      }
    },
    userIdentity() {
      return this.$store.state.user.info.userIdentity;
    },
  },
  created() {
    // console.log(this.$route , '路由参数')
    this.selectedKeys[0] = this.$route.meta.key || this.$route.name;
    console.log(this.selectedKeys);
    this.token = Vue.ls.get(ACCESS_TOKEN);
  },
  methods: {
    getQiniuUrl,
    toBackend() {
      if(this.$store.getters.tenantInfo.backendUrl){
        window.location.href = this.$store.getters.tenantInfo.backendUrl + "/dashboard/index?token=" + this.token;
      }else{
        alert('暂未开放')
      }
    },
    handleClick(e) {},
  },
};
</script>
  
<style lang="less" scoped>
    @import '~@assets/iconfont.css';
.student-side-menu {
  padding-bottom: 20px;
}
.user-info {
  // background-image: url("~@assets/theme/xmw/user-info-bg.png");
  background-size: cover;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .school-area {
    font-size: 14px;
    color: #999;
  }
  .medal {
    width: 40px;
    margin-bottom: 10px;
  }
}
.ant-avatar {
  width: 80px;
  height: 80px;
  padding: 5px;
  background: #fff !important;
}
.ant-menu-item {
  a,
  i {
    font-size: 18px;
  }
}
.menuTitle{
    font-size: 18px;
    a,
    i {
        font-size: 18px;
    }
}
.ziMenu{
    a,
    i {
        font-size: 16px;
    }
}
</style>